import { IframeHTMLAttributes } from "react";
import classNames from "classnames";
import { useT } from "../TranslatedText";
import styles from "../../blocks/StandardTheme/styles/VideoBlock.module.scss";

interface IIframeVideoProps extends IframeHTMLAttributes<HTMLIFrameElement> {
  embedLink: string;
}

export default function IframeVideo(props: IIframeVideoProps) {
  const t = useT();
  const { title, embedLink, ...validHtmlProps } = props;
  const embedResponsiveItemClassName = classNames({
    [styles.embedResponsiveItem]: true,
  });
  return (
    <iframe
      className={embedResponsiveItemClassName}
      title={title?.trim() || t("Video")}
      src={embedLink}
      {...validHtmlProps}
    />
  );
}
